import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=c132d732"
import script from "./ModalItem.vue?vue&type=script&lang=ts"
export * from "./ModalItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c132d732')) {
      api.createRecord('c132d732', component.options)
    } else {
      api.reload('c132d732', component.options)
    }
    module.hot.accept("./ModalItem.vue?vue&type=template&id=c132d732", function () {
      api.rerender('c132d732', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalItem.vue"
export default component.exports